<template>
  <LayoutBase>
    <v-layout class="overflow-inherit!" style="z-index: inherit">
      <v-main>
        <slot />
      </v-main>
    </v-layout>

    <DefaultAppFooter />
  </LayoutBase>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { LayoutBase, DefaultAppFooter } from "@/components/layout";

export default defineComponent({
  components: {
    LayoutBase,
    DefaultAppFooter,
  },
});
</script>
